<template>
  <!-- -->
  <div class="product-hot">
    <alone-text-on-image :data="settingData" class="text"/>
    <div class="product-item" v-for="i in 6" :key="i">
      <alone-image/>
      <div class="product-name">演示商品{{i+1}}</div>
    </div>
  </div>
</template>

<script>

import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";
import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    AloneImage,
    AloneData,
    AloneTextOnImage
  },
  data() {
    return {
      settingData: {}
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {};
      } else {
        this.settingData = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-hot{
  position: relative;
  background-color: #FFF;
  padding: 20px 0;
  :deep(.table-text) {
    position: relative;
    bottom: 0;
  }
  .product-item{
    display: inline-block;
    width: 48%;
    &:nth-child(2n) {
      margin-right: 4%;
    }
    .product-name{
      box-sizing: border-box;
      padding: 0 20px;
      white-space: nowrap;
    }
  }
}
</style>